export function shortFormatNumber(value) {
	return formatNumber(value, { style: 'short' });
}

export function formatNumber(value, options = {}) {
	if (value === null || value === undefined || isNaN(value)) return 'N/A';

	let style = options.style || 'decimal';
	if (options?.style === 'short') {
		if (value >= 1_000_000) {
			return `${(value / 1_000_000).toFixed(1)}M`;
		}
		if (value >= 1_000) {
			return `${(value / 1_000).toFixed(1)}K`;
		}

		style = 'decimal';
	}

	const {
		currency = 'USD',
		minimumFractionDigits,
		maximumFractionDigits,
	} = options;

	const formatter = new Intl.NumberFormat('en-US', {
		style,
		currency,
		minimumFractionDigits,
		maximumFractionDigits,
	});

	return formatter.format(value);
}
